<template>
  <div class="medical-record-exam">
    <div class="border-title text-center">
      <label class="form-label text-bold mb-2">Ceratoscopia</label>
      <div class="columns">
        <div class="column col-4 text-bold"></div>
        <div class="column col-4 text-bold">OD</div>
        <div class="column col-4 text-bold">OE</div>
      </div>
    </div>
    <div class="border-items">
      <div class="columns">
        <div class="column col-4 form-group centered">Astigmastimo DK</div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.astigmatismDkR"
                   step="0.01" min="0" max="30"
                   placeholder="0,00 - 30,00"
                   data-tabindex="1">
            <span class="input-group-addon">D</span>
          </div>
        </div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.astigmatismDkL"
                   step="0.01" min="0" max="30"
                   placeholder="0,00 - 30,00"
                   data-tabindex="2">
            <span class="input-group-addon">D</span>
          </div>
        </div>
        <div class="column col-4 form-group centered">K1 (Flat plano)</div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.k1R"
                   step="0.01" min="20" max="80"
                   placeholder="20,00 - 80,00"
                   data-tabindex="1">
            <input type="number" class="form-input text-center"
                   v-model="form.k1AxisR"
                   step="1" min="0" max="180"
                   placeholder="0 - 180"
                   data-tabindex="1">
            <span class="input-group-addon">&deg;</span>
          </div>
        </div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.k1L"
                   step="0.01" min="20" max="80"
                   placeholder="20,00 - 80,00"
                   data-tabindex="2">
            <input type="number" class="form-input text-center"
                   v-model="form.k1AxisL"
                   step="1" min="0" max="180"
                   placeholder="0 - 180"
                   data-tabindex="2">
            <span class="input-group-addon">&deg;</span>
          </div>
        </div>
        <div class="column col-4 form-group centered">K2 (Steep curvo)</div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.k2R"
                   step="0.01" min="20" max="80"
                   placeholder="20,00 - 80,00"
                   data-tabindex="1">
            <input type="number" class="form-input text-center"
                   v-model="form.k2AxisR"
                   step="1" min="0" max="180"
                   placeholder="0 - 180"
                   data-tabindex="1">
            <span class="input-group-addon">&deg;</span>
          </div>
        </div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.k2L"
                   step="0.01" min="20" max="80"
                   placeholder="20,00 - 80,00"
                   data-tabindex="2">
            <input type="number" class="form-input text-center"
                   v-model="form.k2AxisL"
                   step="1" min="0" max="180"
                   placeholder="0 - 180"
                   data-tabindex="2">
            <span class="input-group-addon">&deg;</span>
          </div>
        </div>
        <div class="column col-4 form-group centered">Kmax</div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                    v-model="form.kmaxR"
                    step="0.01" min="30" max="80"
                    placeholder="30,00 - 80,00"
                   data-tabindex="1">
            <span class="input-group-addon">D</span>
          </div>
        </div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.kmaxL"
                   step="0.01" min="30" max="80"
                   placeholder="30,00 - 80,00"
                   data-tabindex="2">
            <span class="input-group-addon">D</span>
          </div>
        </div>
        <template v-if="!triage">
          <div class="column col-4 form-group centered">Template OD</div>
          <div class="column col-8 form-group">
            <select class="form-select" v-model="form.templateR" @change="loadTemplate('R')">
              <option value="">[Selecione]</option>
              <option v-for="template in templates" :key="template.id" :value="template.id">
                {{ template.name }}
              </option>
            </select>
          </div>
          <div class="column col-4 form-group centered">Laudo OD</div>
          <div class="column col-8 form-group">
            <st-editor v-model="form.reportR"></st-editor>
          </div>
          <div class="column col-4 form-group centered">Template OE</div>
          <div class="column col-8 form-group">
            <select class="form-select" v-model="form.templateL" @change="loadTemplate('L')">
              <option value="">[Selecione]</option>
              <option v-for="template in templates" :key="template.id" :value="template.id">
                {{ template.name }}
              </option>
            </select>
          </div>
          <div class="column col-4 form-group centered">Laudo OE</div>
          <div class="column col-8 form-group">
            <st-editor id="professional-signature"
              v-model="form.reportL"></st-editor>
          </div>
        </template>
        <div class="column col-4 form-group centered">Observações</div>
        <div class="column col-8 form-group">
          <input type="text" class="form-input"
                 v-model="form.observations"
                 placeholder="Observações...">
        </div>
      </div>

      <st-entity-file-manager
        v-if="form.id"
        :entity-id="patient.id"
        :origin-id="medicalRecordId"
        :origin-child-id="form.id"
        origin-type="medical_record_exam"
        :key="medicalRecordId"
      />

      <div class="text-center btn-icon btn-icon-left mt-2">
        <button
          type="button"
          class="btn btn-info mr-2"
          :class="{ loading: saving }"
          @click="save"
        ><fa-icon :icon="['fal', 'save']" /> Salvar</button>
        <button
          type="button"
          class="btn btn-gray-outline btn-icon btn-icon-left mr-2"
          @click="$emit('cancel')"
        ><fa-icon :icon="['fal', 'times']" /> Cancelar</button>
        <button
          v-if="!triage"
          type="button"
          class="btn btn-info-outline btn-icon btn-icon-left mr-2"
          :disabled="true"
        ><fa-icon :icon="['fal', 'history']" /> Histórico</button>
        <st-button-report
          v-if="!triage"
          type="pdf"
          label="Imprimir"
          button-class="btn-gray mr-2"
          :route="printUrl"
          :options="[]"
        />
        <button
          type="button"
          class="btn btn-error btn-icon btn-icon-left"
          :class="{ loading: removing }"
          @click="promptRemoval"
        ><fa-icon :icon="['fal', 'trash']" /> Excluir</button>
      </div>
    </div>
  </div>
</template>

<script>
import formMixin from './formMixin';
import templateMixin from './templateMixin';

export default {
  mixins: [formMixin, templateMixin],
  data() {
    return {
      form: {
        id: null,
        astigmatismDkR: '',
        astigmatismDkL: '',
        k1R: '',
        k1L: '',
        k1AxisR: '',
        k1AxisL: '',
        k2R: '',
        k2L: '',
        k2AxisR: '',
        k2AxisL: '',
        kmaxR: '',
        kmaxL: '',
        reportR: '',
        reportL: '',
        templateR: '',
        templateL: '',
        observations: '',
      },
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";

</style>
